var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[_c('router-view',{attrs:{"apiUrl":_vm.apiUrl,"fields":_vm.fields,"moduleName":_vm.moduleName,"loaded":_vm.loaded,"formClass":_vm.formClass,"listLink":_vm.listLink,"module":_vm.module},on:{"updateTitle":_vm.updateTitle}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b00c1926","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/custom/Custom.vue
// module id = null
// module chunks = 